<template>
    <div class="bar-card ac-panel-content ac-white-panel">
        <div class="bar-card-header-wrap">
            <div class="bar-card-header-inner">
                <slot name="header"></slot>
            </div>
            <div class="bar-card-header-bottom-bar wl-left-panel" aria-hidden="true"></div>
        </div>
        <div class="bar-card-body">
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BarCard"
    };
</script>

<style scoped>
    /* Parent wrappers (e.g. Plans.vue) style .ac-panel-content with a shadow; bar-card supplies its own chrome */
    .bar-card.ac-panel-content {
        box-shadow: none !important;
    }

    /* Bleeds into .ac-panel-content padding; neutral gray (MemberCategoryRow legacy) */
    .bar-card-header-wrap {
        background-color: #d8d8d8;
        margin: -20px -20px 16px -20px;
        padding: 0;
        border-radius: 10px 10px 0 0;
        box-sizing: border-box;
    }

    /* Title insets only; keeps .bar-card-header-bottom-bar full width of the grey strip */
    .bar-card-header-inner {
        padding: 14px 20px 4px 20px;
        box-sizing: border-box;
    }

    /* Whitelabel accent under header */
    .bar-card-header-bottom-bar {
        height: 5px;
        margin-top: 16px;
        width: 100%;
        box-sizing: border-box;
    }

    .bar-card-body {
        background-color: #fff;
    }
</style>

<!-- Slot content is compiled in parents; unscoped so typography applies to slotted nodes via inheritance -->
<!-- Use px so header size matches across apps: general (BS3 html 10px) vs member (BS5 ~16px root). -->
<style>
    .bar-card .bar-card-header-inner {
        display: block;
        font-size: 18px;
        line-height: 1.3;
        font-weight: 700;
        color: #3e3f40;
    }
</style>
